import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IPortfolioNewsArticleEntity } from '../../types'
import type { IPortfolioNewsDetailDTO } from '../contracts/portfolio-news'

export const mapPortfolioNewsDetail = (
  dto: IPortfolioNewsDetailDTO,
): IPortfolioNewsArticleEntity => ({
  id: dto.id,
  articleName: dto.title,
  company: dto.company_display,
  companyTags: dto.company_tags,
  source: dto.source,
  publishedDisplay: DateAdapter.formatToRelativeTime(dto.published_at),
  publishedAt: dto.published_at,
  summaryBullets: dto.summary_bullets,
  articleUrl: dto.article_url,
  emailBody: dto.full_summary,
  contentSource: dto.content_source,
})
